import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Trash2 } from "lucide-react";
import api from "@/lib/api";

const fmt = (v) => String(v || "").slice(0, 16).replace("T", " ");
const MOD = { npi: "NPI Projects", ecn: "ECN Tracker", pipeline: "New Business Pipeline", pipeline_capacity: "Capacity Plan", qms: "QMS", scm_shipment: "SCM Shipments", master: "Master Data" };

export function DeletionLog() {
  const [mod, setMod] = useState("");
  const q = useQuery({ queryKey: ["deletion-log", mod], queryFn: async () => (await api.get("/settings/deletion-log", { params: { module: mod || undefined } })).data });
  const d = q.data;
  return (
    <section className="pp-card p-5 space-y-3" data-testid="deletion-log-panel">
      <div className="flex flex-wrap items-center gap-3">
        <div className="pp-label flex items-center gap-2"><Trash2 size={14} /> Deletion Log · who deleted what</div>
        <select className="pp-input h-8 text-xs w-48 ml-auto" value={mod} onChange={(e) => setMod(e.target.value)} data-testid="deletion-log-module">
          <option value="">All modules</option>{(d?.modules || []).map((m) => <option key={m} value={m}>{MOD[m] || m}</option>)}
        </select>
      </div>
      {q.isLoading && <div className="h-16 animate-pulse rounded bg-slate-100" />}
      {d && d.rows.length === 0 && <div className="text-xs text-slate-400" data-testid="deletion-log-empty">No deletions recorded yet.</div>}
      {d && d.rows.length > 0 && <div className="overflow-x-auto max-h-80"><table className="pp-table text-xs w-full" data-testid="deletion-log-table">
        <thead><tr><th className="text-left">When</th><th className="text-left">Module</th><th className="text-left">Deleted item</th><th className="text-left">By</th></tr></thead>
        <tbody>{d.rows.map((r) => <tr key={r.id} data-testid={`deletion-row-${r.id}`}>
          <td className="whitespace-nowrap text-slate-500">{fmt(r.at)}</td><td>{MOD[r.module] || r.module}</td>
          <td className="max-w-[360px]">{r.label}</td><td>{r.by_name} <span className="text-slate-400">· {r.by_email} · {r.role}</span></td></tr>)}</tbody>
      </table></div>}
    </section>
  );
}
